module.exports = __webpack_public_path__ + "static/media/missions.b6491ae5.png";